import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import { selectSedes } from "../../../Sedes/services/sedes-service";
import FormModal from "../../../../core/ui/components/FormModal";
import { crearOEditarTurno } from "../../services/nomina-turnos-service";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const YES_OR_NO_OPTIONS = [
    { label: "SI", value: 1 },
    { label: "NO", value: 0 },
];

const FormNominaTurno = ({ modalState, onSaved }) => {
    const { turno } = modalState.data;
    const [sedes, setSedes] = useState([]);

    const pagadoTurno = {
        label: turno.pagado == 1 ? "SI" : "NO",
        value: turno.pagado == 1 ? 1 : 0,
    };

    const globalTurno = {
        label: turno.libre == 1 ? "SI" : "NO",
        value: turno.libre == 1 ? 1 : 0,
    };

    const defaultValues = {
        libre: globalTurno,
        pagado: pagadoTurno,
        id: turno.id == null ? "" : turno.id,
        fin: turno.fin != null ? turno.fin : "",
        sedes: turno.sedes != null ? turno.sedes : [],
        sigla: turno.sigla != null ? turno.sigla : "",
        nombre: turno.nombre != null ? turno.nombre : "",
        inicio: turno.inicio != null ? turno.inicio : "",
        color: turno.color != null ? turno.color : "#000000",
        fin_receso: turno.fin_receso != null ? turno.fin_receso : 0,
        inicio_receso: turno.inicio_receso != null ? turno.inicio_receso : 0,
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [turno]);

    const onCreateTurno = async (turno) => {
        const resp = await crearOEditarTurno({
            ...turno,
            pagado: turno.pagado.value,
            libre: turno.libre.value,
            sedes: turno.sedes.map((sede) => sede.value),
        });

        if (!resp.status) return toast.error(resp.message);
        onSaved();
    };

    useEffect(async () => {
        const resp = await selectSedes({ status: 1 });
        if (!resp.status) return toast.error(resp.message);
        setSedes(resp.data);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formTurnos"
            onSubmit={onCreateTurno}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    type="hidden"
                    name="id"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={4}>
                    <InputController
                        label="Nombre"
                        errors={form.formState.errors}
                        control={form.control}
                        name="nombre"
                        rules={REQUIRED_RULE}
                        placeholder="Nombre del turno"
                    />
                </Col>
                <Col sm={4}>
                    <InputController
                        label="Sigla"
                        errors={form.formState.errors}
                        control={form.control}
                        name="sigla"
                        rules={REQUIRED_RULE}
                        placeholder="Sigla del turno"
                    />
                </Col>
                <Col sm={4}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="pagado"
                        label="Turno Pagado"
                        rules={REQUIRED_RULE}
                        options={YES_OR_NO_OPTIONS}
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        type="time"
                        errors={form.formState.errors}
                        control={form.control}
                        name="inicio"
                        rules={REQUIRED_RULE}
                        label="Hora inicio turno"
                        placeholder="Hora de inicio"
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        name="fin"
                        type="time"
                        rules={REQUIRED_RULE}
                        control={form.control}
                        label="Hora fin turno"
                        placeholder="Hora de fin"
                        errors={form.formState.errors}
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        type="time"
                        name="inicio_receso"
                        control={form.control}
                        label="Hora Inicio Receso"
                        placeholder="Inicio Receso"
                        errors={form.formState.errors}
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        type="time"
                        name="fin_receso"
                        control={form.control}
                        label="Hora Fin Receso"
                        placeholder="Fin Receso"
                        errors={form.formState.errors}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        label="Sede"
                        name="sedes"
                        isMulti={true}
                        errors={form.formState.errors}
                        control={form.control}
                        rules={REQUIRED_RULE}
                        options={sedes.map((sede) => {
                            return {
                                label: sede.sigla,
                                value: sede.id,
                            };
                        })}
                    />
                </Col>
                <Col sm={3}>
                    <SelectController
                        errors={form.formState.errors}
                        control={form.control}
                        name="libre"
                        label="Turno Libre"
                        rules={REQUIRED_RULE}
                        options={YES_OR_NO_OPTIONS}
                    />
                </Col>
                <Col sm={3}>
                    <InputController
                        type="color"
                        label="Color"
                        errors={form.formState.errors}
                        control={form.control}
                        name="color"
                        rules={REQUIRED_RULE}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormNominaTurno.propTypes = {
    modalState: PropTypes.object,
    onSaved: PropTypes.func
}

export default FormNominaTurno;
